import React, {Fragment, useState} from 'react';
import './account-verification.scss';
import emailVerification from '../../assets/email-verification.jpg';
import {Link, useHistory} from 'react-router-dom';
import Navbar from '../nav-bar/nav-bar';
import {Button} from 'devextreme-react/button';
import api from '../../api/auth';

const AccountVerification = (props) => {
    const history = useHistory();
    const [message,setMessage] = useState();
    //console.log("test",props?.location?.state?.email);
    const resendEmailBtnOnClick = () => {
        api.resendEmail(props?.location?.state?.email).then(result => {
            console.log("trst",result);
            setMessage(result.data)
        })
    }
    return (
        <Fragment>
            <div className={'account'}>
                <Navbar/>
                <div className={'email-info'}>
                    <div className={'account-middle'}>
                        <h2>Thank you for registering</h2>
                        <h5>We e-mailed you a verification link. Click on it to confirm your email address.</h5>
                        <p>If you don't receive the email please check your spam box or we can
                            <Button
                                className={'btn-verify'}
                                type="default"
                                stylingMode="text"
                                onClick={resendEmailBtnOnClick}>send it over again</Button>
                        </p>
                        <p className={'resend-text'}>{message}</p>
                        <p>
                            If you still haven't received it please
                            <Button
                                className={'btn-verify'}
                                type="default"
                                stylingMode="text"
                                href="mailto:support@shipsland.com">contact us</Button>
                        </p>
                    </div>
                    <div className={'account-right'}>
                        <img alt="email-verification" src={emailVerification}/>
                    </div>
                </div>
            </div>
        </Fragment>
    );
}
export default AccountVerification;